import { httpMethod, useApi } from './useApi';
export const useCreateReview = () => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        path: `reviews`,
        httpMethod: httpMethod.POST,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, ...rest };
};
export const useGetReview = ({ reviewId }) => {
    const { call, data, ...rest } = useApi({
        authenticated: false,
        path: `reviews/${reviewId}`,
        httpMethod: httpMethod.GET,
    });
    const responseData = data;
    return { call, data: responseData, ...rest };
};
